import { navigate } from 'gatsby';
import React, { forwardRef, useImperativeHandle } from 'react';

import {
  customerAddressCreate,
  customerAddressDelete,
  customerAddressSetDefault,
  customerAddressUpdate,
  getCustomer,
  logout,
} from '../../services/shopify';

const Addresses = ({ children }, ref) => {
  useImperativeHandle(ref, () => ({
    getCustomer() {
      return getCustomer().then(({ customer }) => {
        if (customer) {
          return customer;
        } else {
          logout(() => navigate(`/account/login`));
        }
      });
    },

    customerAddressCreate(input) {
      return customerAddressCreate(input).then(({ customerAddressCreate }) => {
        if (customerAddressCreate && customerAddressCreate.customerAddress) {
          return customerAddressCreate.customerAddress;
        } else {
          logout(() => navigate(`/account/login`));
        }
      });
    },

    customerAddressDelete(input) {
      return customerAddressDelete(input).then(({ customerAddressDelete }) => {
        if (
          customerAddressDelete &&
          customerAddressDelete.deletedCustomerAddressId
        ) {
          return customerAddressDelete.deletedCustomerAddressId;
        } else {
          logout(() => navigate(`/account/login`));
        }
      });
    },

    customerAddressSetDefault(input) {
      return customerAddressSetDefault(input).then(
        ({ customerDefaultAddressUpdate }) => {
          if (
            customerDefaultAddressUpdate &&
            customerDefaultAddressUpdate.customer
          ) {
            return customerDefaultAddressUpdate.customer;
          } else {
            logout(() => navigate(`/account/login`));
          }
        }
      );
    },

    customerAddressUpdate(input) {
      return customerAddressUpdate(input).then(({ customerAddressUpdate }) => {
        if (customerAddressUpdate && customerAddressUpdate.customerAddress) {
          return customerAddressUpdate.customerAddress;
        } else {
          logout(() => navigate(`/account/login`));
        }
      });
    },
  }));

  return <>{children}</>;
};

export default forwardRef(Addresses);
